module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figF02_example-transmission-error.871c2b60.png";